module.exports = __webpack_public_path__ + "img/panking_1@3x.59882997.png";